import React, { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from "recharts";
import styled from "styled-components";

const CustomTooltip = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 170px;
  backdrop-filter: blur(10px);
`;

const TooltipText = styled.p`
  margin: 6px 0;
  font-size: 14px;
  color: #2c3e50;
`;

const TooltipMain = styled.h3`
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #154360;
  border-bottom: 2px solid #b7950b;
  padding-bottom: 6px;
`;

// const StyledButton = styled.button`
//   background: linear-gradient(135deg, #008080, #b7950b);
//   border: none;
//   color: white;
//   padding: 10px 16px;
//   border-radius: 6px;
//   font-size: 14px;
//   cursor: pointer;
//   transition: all 0.3s ease;

//   &:hover {
//     background: linear-gradient(135deg, #007777, #a67c00);
//     transform: scale(1.05);
//   }
// `;

const CustomTooltipContent = ({ active, payload, dataKey }) => {
  if (!active || !payload || payload.length === 0) return null;

  const data = payload[0].payload;
  const subject = data?.subject || data?.subName?.subName;
  const attendancePercentage = data?.attendancePercentage?.toFixed(1);
  const totalClasses = data?.totalClasses;
  const attendedClasses = data?.attendedClasses;
  const marksObtained = data?.marksObtained;

  return (
    <CustomTooltip>
      {dataKey === "attendancePercentage" ? (
        <>
          <TooltipMain>{subject}</TooltipMain>
          {totalClasses !== undefined && attendedClasses !== undefined && (
            <TooltipText>
              Attendance: {attendedClasses}/{totalClasses}
            </TooltipText>
          )}
          <TooltipText>Percentage: {attendancePercentage}%</TooltipText>
        </>
      ) : (
        <>
          <TooltipMain>{subject}</TooltipMain>
          <TooltipText>Marks: {marksObtained}</TooltipText>
        </>
      )}
    </CustomTooltip>
  );
};

const COLOR_PALETTE = ["#008080", "#b7950b", "#FFD700", "#20B2AA", "#2F4F4F"];

const CustomBarChart = ({ chartData, dataKey }) => {
  const colorMap = useMemo(() => {
    const subjects = chartData?.map(data => data.subject) || [];
    return subjects.reduce((acc, subject, index) => ({
      ...acc,
      [subject]: COLOR_PALETTE[index % COLOR_PALETTE.length]
    }), {});
  }, [chartData]);

  if (!chartData || chartData.length === 0) {
    return <div style={{ textAlign: "center", padding: "20px" }}>No data available for chart</div>;
  }

  const maxValue = Math.max(...chartData.map(item => item[dataKey])) * 1.1;

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
          <XAxis
            dataKey="subject"
            interval={0}
            angle={-45}
            textAnchor="end"
            height={90}
            tick={{ fontSize: 12, fill: "#154360" }}
          />
          <YAxis
            domain={[0, dataKey === "attendancePercentage" ? 100 : maxValue]}
            tickFormatter={value => dataKey === "attendancePercentage" ? `${value}%` : value}
            tick={{ fontSize: 12, fill: "#154360" }}
          />
          <Tooltip content={<CustomTooltipContent dataKey={dataKey} />} cursor={{ fill: "#f5f5f5" }} />
          <Bar dataKey={dataKey} barSize={30}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colorMap[entry.subject] || COLOR_PALETTE[index % COLOR_PALETTE.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      
    </div>
  );
};

export default CustomBarChart;
